import Vue from "vue";
import App from "./App.vue";

import "./css/index.less";
import router from "./router";
import store from "./store";

import Card from "./components/card.vue";
import Money from "./components/money.vue";
import Upload from "./components/upload/index.vue";
import Padding from "./components/padding";

import Num from "./components/num.vue";

import {
  Radio,
  ConfigProvider,
  Checkbox,
  Select,
  Modal as AModal,
  Slider,
  Button,
  Row,
  Col,
  Icon,
  Tabs,
  DatePicker,
  message,
  Descriptions,
  Form,
  FormModel,
  Table,
  Result,
  Input,
  Space,
  InputNumber,
  Cascader,
  Badge,
  Dropdown,
  Menu,
  Divider,
  Tag,
  Switch,
  Empty,
  Alert,
  AutoComplete,
} from "ant-design-vue";

import Title from "./components/title";

import Modal from "@/components/water-affairs-style/modal";

import DataDictFinder from "./components/data-dict-finder.vue";

import { selectFilterOption, ratioFormatter } from "@/utils/antdv";
import { print, download } from "@/utils/download";
import { getFileName } from "./utils/file";
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
import ButtonExport from "@/components/water-affairs-style/field/ButtonExport.vue";
import Tablelist from "@/components/water-affairs-style/table-list.vue";
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
import RangePickerField from "@/components/water-affairs-style/field/RangePickerField.vue";
import CascaderField from "@/components/water-affairs-style/field/CascaderField.vue";
import RadioField from "@/components/water-affairs-style/field/RadioField.vue";
import TextareaField from "@/components/water-affairs-style/field/textareaField.vue";
import UploadField from "@/components/water-affairs-style/field/UploadField.vue";
import DatePickerField from "@/components/water-affairs-style/field/DatePickerField.vue";
import Toast from "@/components/water-affairs-style/field/Toast.vue";

import StatCard from "@/components/water-affairs-style/StatCard.vue";
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

const ToastConstructor = Vue.extend(Toast);
let isToastVisible = false; // 标志位，用于判断是否有提示框正在显示

Vue.prototype.$toast = {
  show(message, duration = 5, offset = 20, type = 'info') {
    // 如果已经有提示框显示，先隐藏它
    if (isToastVisible) {
      this.hide();
    }

    const toastInstance = new ToastConstructor({
      propsData: {
        visible: true,
        message,
        duration,
        offset,
        type,
      },
    });
    toastInstance.$mount();
    document.body.appendChild(toastInstance.$el);

    isToastVisible = true;

    // 设置隐藏逻辑
    setTimeout(() => {
      this.hide(toastInstance);
    }, duration * 1000);
  },
  hide(instance) {
    if (!instance) {
      const toastElement = document.querySelector('.toast');
      if (toastElement) {
        toastElement.parentNode.removeChild(toastElement);
      }
    } else {
      instance.$destroy();
      instance.$el.parentNode.removeChild(instance.$el);
    }
    isToastVisible = false;
  },
  error(message) {
    this.show(message, 5, 20, 'error');
  },
  info(message) {
    this.show(message, 5, 20, 'info');
  },
};
Vue.component("StatCard", StatCard);
Vue.component("Modal", Modal);
Vue.component("DataDictFinder", DataDictFinder);
Vue.component("InputField", InputField);
Vue.component("ButtonExport", ButtonExport);
Vue.component("ButtonField", ButtonField);
Vue.component("Tablelist", Tablelist);
Vue.component("SelectField", SelectField);
Vue.component("RangePickerField", RangePickerField);
Vue.component("CascaderField", CascaderField);
Vue.component("RadioField", RadioField);
Vue.component("TextareaField", TextareaField);
Vue.component("UploadField", UploadField);
Vue.component("DatePickerField", DatePickerField);


Vue.use(Radio)
  .use(ConfigProvider)
  .use(Checkbox)
  .use(Slider)
  .use(Button)
  .use(Row)
  .use(Col)
  .use(Select)
  .use(Icon)
  .use(Tabs)
  .use(DatePicker)
  .use(FormModel)
  .use(Table)
  .use(Result)
  .use(Input)
  .use(Space)
  .use(Form)

  .use(AModal)
  .use(InputNumber)
  .use(Cascader)
  .use(Badge)
  .use(Dropdown)
  .use(Menu)
  .use(Divider)
  .use(Descriptions)
  .use(Tag)
  .use(Switch)
  .use(Empty)
  .use(Alert)
  .use(AutoComplete)
  .use(VueQuillEditor)
Vue.component("Title", Title);

Vue.component("Card", Card);
Vue.component("Money", Money);
Vue.component("Upload", Upload);
Vue.component("Num", Num);
Vue.component("Padding", Padding);

message.config({
  maxCount: 1,
});

Vue.prototype.$message = message;
Vue.prototype.$confirm = AModal.confirm;
Vue.prototype.$error = AModal.error;
Vue.prototype.$success = AModal.success;

Vue.prototype.$selectFilterOption = selectFilterOption;
Vue.prototype.$ratioFormatter = ratioFormatter;
Vue.prototype.$getFileName = getFileName;

Vue.prototype.$print = print;
Vue.prototype.$download = download;
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
